import { useShallow } from 'zustand/react/shallow';
import { useStore } from '@/legacy/store/zustand';

export const useTopBarNotifications = () => {
	const { unreadCount, openOffcanvas } = useStore(
		useShallow((state) => ({
			unreadCount: Object.values(state.notifications).filter((n) => !n.readed).length,
			openOffcanvas: state.openOffcanvas,
		})),
	);

	return { unreadCount, openOffcanvas };
};
